import React, { useState, useEffect, useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  Home,
  Calendar,
  MessageSquare,
  Heart,
  Settings,
  Bell,
  CreditCard,
  Shield,
  X,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  LogOut,
  User,
  HelpCircle,
  ArrowLeft ,
  Menu
} from 'lucide-react';
import { Modal, Button } from 'react-bootstrap';
import '../../../../assets/css/customer/customerdashboard/customerLayout/customersidebar.css';
import AppContext from '../../../../context/AppContext';
import logo from '../../../../assets/images/logo.jpg';

const Sidebar = ({ isOpen, toggleSidebar, onCollapse }) => {
  const navigate = useNavigate();
  const { customerloggedin } = useContext(AppContext);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  const mainMenuItems = [
    { path: "/customer/dashboard", icon: <Home size={20} />, label: "My Bookings" },
    // { path: "/customer/bookings", icon: <Calendar size={20} />, label: "My Bookings" },
    { path: "/customer/ai-planner", icon: <MessageSquare size={20} />, label: "AI Planner" },
    { path: "/customer/wishlist", icon: <Heart size={20} />, label: "My Wishlist" },
    { path: "/customer/profile", icon: <User size={20} />, label: "My Profile" },
        { path: "/customer/cus-notifications", icon: <User size={20} />, label: "Notifications" },

    { path: "/customer/help-support", icon: <HelpCircle size={20} />, label: "Help & Support" },
  ];
  const {authToken,setAuthToken}=useContext(AppContext);
    useEffect(()=>{
      console.log("--------Customer Token------");
      const token=localStorage.getItem("authToken");
      setAuthToken(token);
      console.log(authToken);
    },[]);
  
  const settingsMenuItems = [
    { path: "/customer/settings/notifications", icon: <Bell size={18} />, label: "Notifications" },
    { path: "/customer/settings/security", icon: <Shield size={18} />, label: "Security" },
  ];

  const toggleCollapse = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    if (onCollapse) onCollapse(newCollapsedState);
  };

  const toggleSettings = () => setSettingsOpen(!settingsOpen);

  const handleMenuClick = () => {
    if (window.innerWidth < 992 && isOpen) {
      toggleSidebar();
    }
  };

  const handleLogout = () => setShowLogoutModal(true);

  const confirmLogout = () => {
    setShowLogoutModal(false);
    customerloggedin();
    navigate("/");
  };

  const cancelLogout = () => setShowLogoutModal(false);

  useEffect(() => {
    if (onCollapse) onCollapse(isCollapsed);
  }, [isCollapsed, onCollapse]);

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div className="cus-sdb-sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      {/* Sidebar */}
      <div className={`cus-sdb-sidebar-wrapper ${isCollapsed ? 'cus-sdb-collapsed' : ''} ${isOpen ? 'cus-sdb-open' : ''}`}>

        <div className="cus-sdb-sidebar-logo">
          <div className="cus-sdb-logo-container">

            {isCollapsed && (
  <img
    src={logo}
    alt="Journey Junction"
    className="cus-sdb-collapsed-logo"
  />
)}

            {!isCollapsed && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>

                <button
                  onClick={() => navigate('/')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: 'rgba(255,255,255,0.15)',
                    border: '1px solid rgba(255,255,255,0.25)',
                    borderRadius: '8px',
                    padding: '0px 12px',
                    cursor: 'pointer',
                    color: 'inherit',
                    width: 'fit-content',
                    transition: 'background 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
                  title="Back to Home"
                >
                  <ArrowLeft size={20} />
                </button>

                <div className="cus-sdb-brand">
  <img
    src={logo}
    alt="Journey Junction"
    className="cus-sdb-brand-logo"
  />

  <div className="cus-sdb-logo-text">
    <h3>Journey Junction</h3>
    <p>Customer Panel</p>
  </div>
</div>

              </div>
            )}
          </div>

          <button className="cus-sdb-sidebar-close-btn d-lg-none" onClick={toggleSidebar}>
            <X size={22} />
          </button>
        </div>

        <div className="cus-sdb-sidebar-menu">
          <div className="cus-sdb-menu-section">
            <div className="cus-sdb-menu-items">

              {/* Main items */}
              {mainMenuItems.map((item, index) => (
                <NavLink
                  key={index}
                  to={item.path}
                  onClick={handleMenuClick}
                  className={({ isActive }) =>
                    `cus-sdb-menu-item ${isActive ? 'cus-sdb-active' : ''}`
                  }
                  end={item.path === "/customer/dashboard"}
                >
                  <span className="cus-sdb-menu-icon">{item.icon}</span>
                  {!isCollapsed && <span className="cus-sdb-menu-label">{item.label}</span>}
                </NavLink>
              ))}

              {/* Settings Dropdown */}
              <div className="cus-sdb-settings-dropdown">
                <button
                  onClick={toggleSettings}
                  className="cus-sdb-menu-item cus-sdb-settings-toggle"
                >
                  <span className="cus-sdb-menu-icon"><Settings size={20} /></span>
                  {!isCollapsed && <span className="cus-sdb-menu-label">Settings</span>}
                  {!isCollapsed && (
                    <span className="cus-sdb-dropdown-arrow">
                      {settingsOpen ? <ChevronUp size={15} /> : <ChevronDown size={15} />}
                    </span>
                  )}
                </button>

                {settingsOpen && !isCollapsed && (
                  <div className="cus-sdb-submenu">
                    {settingsMenuItems.map((item, index) => (
                      <NavLink
                        key={index}
                        to={item.path}
                        onClick={handleMenuClick}
                        className={({ isActive }) =>
                          `cus-sdb-submenu-item ${isActive ? 'cus-sdb-active' : ''}`
                        }
                      >
                        <span className="cus-sdb-submenu-icon">{item.icon}</span>
                        <span className="cus-sdb-submenu-label">{item.label}</span>
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>

              {/* Logout */}
              <button
                onClick={handleLogout}
                className="cus-sdb-menu-item cus-sdb-logout-menu-item"
              >
                <span className="cus-sdb-menu-icon"><LogOut size={20} /></span>
                {!isCollapsed && <span className="cus-sdb-menu-label">Logout</span>}
              </button>

            </div>
          </div>
        </div>

        {/* Toggle button — desktop only */}
        <div className="cus-sdb-sidebar-toggle-btn">
          <button onClick={toggleCollapse} className="cus-sdb-toggle-btn">
           {isCollapsed ? <Menu size={18} /> : <X size={18} />}
          </button>
        </div>
      </div>

      {/* Logout Modal */}
      <Modal show={showLogoutModal} onHide={cancelLogout} centered backdrop="static">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center">
            <div className="text-warning mb-2">
              <LogOut size={48} />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center px-4 pb-4">
          <h5 className="fw-bold mb-3">Confirm Logout</h5>
          <p className="text-muted mb-0">
            Are you sure you want to logout? <br />
            You will be redirected to the home page.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-4">
          <Button variant="outline-secondary" onClick={cancelLogout} className="px-4 py-2">
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmLogout} className="px-4 py-2">
            <LogOut size={18} className="me-2" />
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Sidebar;